<template>
    <v-app>
        <v-app-bar app dark color="primary" flat>
            <router-link to="/" v-if="!isMobile">
                <v-toolbar-title @click="selectStory()"
                                 style="padding-left: 14px; color: white;">Story
                    Atlas of Sustainable Development Goals
                </v-toolbar-title>
            </router-link>
            <v-spacer></v-spacer>
            <v-btn :text="!isMobile" :icon="isMobile" to="/"
                   @click="selectStory()" @click.middle="blur($event)">
                <span v-if="!isMobile">Content</span>
                <v-icon v-if="isMobile">mdi-table-of-contents</v-icon>
            </v-btn>
            <v-btn :text="!isMobile" :icon="isMobile"
                   v-if="stories.current === null" to="/background"
                   @click.middle="blur($event)">
                <span v-if="!isMobile">Background</span>
                <v-icon v-if="isMobile">mdi-lightbulb</v-icon>
            </v-btn>
            <v-btn :text="!isMobile" :icon="isMobile"
                   v-if="stories.current === null" to="/imprint"
                   @click.middle="blur($event)">
                <span v-if="!isMobile">Imprint</span>
                <v-icon v-if="isMobile">mdi-information</v-icon>
            </v-btn>
            <v-btn :text="!isMobile" :icon="isMobile"
                   v-if="stories.current !== null" @click="previousStory()">
                <span v-if="!isMobile">Previous topic</span>
                <v-icon v-if="isMobile">mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn :text="!isMobile" :icon="isMobile"
                   v-if="stories.current !== null" @click="nextStory()">
                <span v-if="!isMobile">Next topic</span>
                <v-icon v-if="isMobile">mdi-chevron-right</v-icon>
            </v-btn>
        </v-app-bar>
        <v-main>
            <router-view/>
        </v-main>
        <v-footer v-if="isMobile && stories.current === null" dark
                  color="primary" class="d-flex justify-center flex-column">
            <div style="padding: 6px; text-align: center">Story Atlas of
                Sustainable Development Goals
            </div>
        </v-footer>
    </v-app>
</template>
<script>
    import stories from "@/models/stories";

    export default {
        name: 'App',
        data: () => ({
            stories
        }),
        methods: {
            blur: function (ev) {
                //workaround for removing focus of <a> element after mouse wheel click
                ev.target.parentElement.blur();
            },
            previousStory: function () {
                this.stories.current -= 1;

                if (this.stories.current === -1)
                  this.stories.current = this.stories.items.length - 1;

                this.$router.push(this.stories.items[this.stories.current].route);
            },
            nextStory: function () {
              this.stories.current += 1;

                if (this.stories.current === this.stories.items.length)
                  this.stories.current = 0;

                this.$router.push(this.stories.items[this.stories.current].route);
            },
            selectStory: function () {
              this.stories.current = null;
            }
        },
        computed: {
            isMobile() {
                return this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly;
            }
        }
    };
</script>
<style>
    /* icon button hover state is strangely triggered after clicking on mobile devices */
    @media (max-width: 960px) {
        .v-btn:hover:before {
            opacity: 0 !important;
        }
    }
</style>
